import { HStack, Avatar, Text, Icon } from "@chakra-ui/react";
import { InstagramAccount } from "../types";
import { getIconComponent } from "src/Manager/FeedManager/SocialInput";

interface InstagramIdentityProps {
  id?: string;
  instagramAccounts?: InstagramAccount[];
}

const InstagramIdentity = ({
  id,
  instagramAccounts,
}: InstagramIdentityProps) => {
  if (!id) return null;

  const getInstagramAccountIdentityFromId = (id?: string) => {
    return instagramAccounts?.find((account) => account.id === id)?.username;
  };

  const SocialMediaIcon = getIconComponent("instagram");

  return (
    <HStack>
      <Avatar size="xs" />
      <Text>{getInstagramAccountIdentityFromId(id)}</Text>
      <Text color="gray.200">
        <Icon fontSize="18px" as={SocialMediaIcon} />{" "}
      </Text>
    </HStack>
  );
};

export default InstagramIdentity;
